import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseServiceFacade } from '../../../../common/store/types';
import { AppState } from '../../types';

@Injectable()
export class CallService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }
}
